<template>
  <div class="p-col-12">
    <page-header title="forms.timeline-predefinition.title" :actions="pageActions"/>
    <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
  </div>
</template>

<script>
import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
import FrontBusiness from "@/business/FrontBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import PageHeader from "@/components/page/PageHeader";
import Audit from "@/viewer/user/Audit";
import TimelinePredefinitionBusiness from "@/business/TimelinePredefinitionBusiness";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";

export default {
  name: "TimelinePredefinitionList",
  components: {PageHeader, AncestrylineDataTable},

  data() {
    return {
      dataFunction: TimelinePredefinitionBusiness.pagination,
      columns: [
        {field: "name", header: 'forms.timeline-predefinition.name', sortable:true},
        {field: "code", header: 'forms.timeline-predefinition.code', sortable:true},
        {field: "created", header: 'forms.timeline-predefinition.created', sortable:true, type: 'date-time'},
        {field: "active", header: 'forms.timeline-predefinition.active', sortable:true, type: 'boolean'},
        {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
          actions: [
            {icon: 'pi pi-pencil', title: 'forms.timeline-predefinition.edit', function: this.editTimelinePredefinition},
            {icon: 'pi pi-trash', title: 'forms.timeline-predefinition.delete', function: this.deleteTimelinePredefinition, refreshList: true},
          ]
        },
      ],
      pageActions: [
        {icon: 'pi pi-plus', label: 'forms.timeline-predefinition.add', url: '/timeline-predefinition', type: 'link'},
        {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
      ],
    }
  },

  methods: {

    editTimelinePredefinition(timelinePredefinition){
      FrontBusiness.redirect(`/timeline-predefinition/${timelinePredefinition.id}`);
    },

    async deleteTimelinePredefinition(timelinePredefinition, dataList){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await TimelinePredefinitionBusiness.delete(timelinePredefinition.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          dataList = dataList.filter(c => c.id !== timelinePredefinition.id);
          ToastMessageBusiness.showSuccess();
        }
        return dataList;
      }
    },

    openModal(){
      DialogService.openModal(Audit, {business: TimelinePredefinitionBusiness});
    }

  }

}
</script>

<style scoped>

</style>